export default function sortSections(sections) {
  return sections
    .valueSeq()
    .sortBy(s => s.get("priority"))
    .map(s => s.remove("icon"))
    .map(s => s.set("title", s.get("name")))
    .filter(section => section.get("privilegeCode") !== "available");
}
